<template>
	<select :id="id" @change="change" v-model="selected" class='form-control my-control' data-num='f_9' data-table='1' :class='field_class'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const FORESTRY = 'forestrie_list.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'forestry',
		data: function () { 
			return {
				selected: '0',
				options: [],
				id: `${this.type}_forestry`
			}
		},
		props: {
			type: '',
			field_class: '',
			forestry_id: null
		},
		watch: {
			forestry_id(val) {
				this.selected = val
			}
		},
		methods: {
			checkDisableOnButtons() {
				let btnAddLine = document.getElementById('btnAddLine')
				let btnCopyLine = document.getElementById('btnCopyLine')
				let btnDeleteLine = document.getElementById('btnDeleteLine')

				if (this.selected === '0') {
					btnAddLine.disabled = true
					btnCopyLine.disabled = true
					btnDeleteLine.disabled = true
				}
				else {
					btnAddLine.disabled = false
					btnCopyLine.disabled = false
					btnDeleteLine.disabled = false
				}
			},
			fill: function (id) {
				//console.log(id)
				fetch(DB + FORESTRY + '?id=' + id)
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = [{id: '0', name: ''}, ...data];
						if(this.forestry_id) {
							this.selected = this.forestry_id
						}
					}
					else {
						this.selected = '0'
						//console.log(this.selected)
						this.options = []
					}
				})
				.then(() => {
					this.checkDisableOnButtons()
				})
				.catch(err => console.log(err))
			},
			change: function () {
				this.checkDisableOnButtons()
				EventBus.$emit(`${this.type}_forestry`, this.selected)
			}
		},
		created () {
			EventBus.$on(`${this.type}_region`, id => {
				this.fill(id)
			})

		},
		beforeDestroy () {
			EventBus.$off(`${this.type}_region`)
		}
	}
</script>


// WEBPACK FOOTER //
// forestry.vue?a1a8c120